import { useState, useEffect, useCallback } from 'react';
import { useUtilsState } from '@src/shared/hooks';

export const useScrollHandler = (openModelMoreDetails?: boolean) => {
  const [isFixed, setIsFixed] = useState(false);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);
  const { footerHeight } = useUtilsState();

  const scrollToTop = useCallback(() => {
    const scrollHeight = window.scrollY;
    const duration = 750;
    const startTime = performance.now();

    const scroll = (timestamp: number) => {
      const elapsedTime = timestamp - startTime;
      const scrollPosition = Math.max(
        scrollHeight - (elapsedTime / duration) * scrollHeight,
        0
      );
      window.scrollTo(0, scrollPosition);

      if (elapsedTime < duration) {
        requestAnimationFrame(scroll);
      }
    };

    requestAnimationFrame(scroll);
  }, []);

  const handleScroll = useCallback(() => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const documentHeight = document.documentElement.offsetHeight;
    const scrollUp = lastScrollPosition > scrollPosition;
    const scrollDown = lastScrollPosition < scrollPosition;

    if (scrollUp) {
      if (scrollPosition < documentHeight - footerHeight) {
        if (!openModelMoreDetails) {
          setIsFixed(true);
        }
      }
    }

    if (scrollDown) {
      if (scrollPosition >= documentHeight - footerHeight) {
        setIsFixed(false);
      }
    }

    setLastScrollPosition(scrollPosition);
  }, [lastScrollPosition, openModelMoreDetails, footerHeight]);

  useEffect(() => {
    if (openModelMoreDetails) {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [openModelMoreDetails, handleScroll]);

  useEffect(() => {
    if (!openModelMoreDetails) {
      window.addEventListener('scroll', handleScroll);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [openModelMoreDetails, lastScrollPosition, handleScroll]);

  return { isFixed, setIsFixed, scrollToTop };
};
